import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { FlaskConical, Loader2, Lock } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-5" data-testid="login-page">
      <div className="w-full max-w-md bg-white rounded-[2rem] p-8 md:p-10 border border-slate-100 shadow-[0_30px_80px_-30px_rgba(10,37,64,0.3)]">
        <div className="flex items-center gap-2.5 justify-center mb-6">
          <div className="w-12 h-12 rounded-2xl bg-navy flex items-center justify-center"><FlaskConical className="w-6 h-6 text-turq-light" /></div>
        </div>
        <h1 className="font-heading text-2xl font-bold text-navy text-center">Staff Login</h1>
        <p className="text-secondary text-sm text-center mt-1">DOABA Diagnostics Admin Dashboard</p>

        <form onSubmit={submit} className="mt-7 space-y-4">
          <div><Label className="text-navy text-sm mb-1.5 block">Email</Label>
            <Input className="bg-slate-50 border-slate-200 rounded-2xl px-5 py-3 h-auto focus-visible:ring-turq" value={email} onChange={(e) => setEmail(e.target.value)} type="email" data-testid="login-email-input" /></div>
          <div><Label className="text-navy text-sm mb-1.5 block">Password</Label>
            <Input className="bg-slate-50 border-slate-200 rounded-2xl px-5 py-3 h-auto focus-visible:ring-turq" value={password} onChange={(e) => setPassword(e.target.value)} type="password" data-testid="login-password-input" /></div>
          {error && <p className="text-sm text-red-500" data-testid="login-error">{error}</p>}
          <Button type="submit" disabled={loading} className="w-full rounded-full bg-navy hover:bg-navy-light py-6 text-base" data-testid="login-submit-btn">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Lock className="w-4 h-4 mr-2" /> Sign In</>}
          </Button>
        </form>
        <a href="/" className="block text-center text-sm text-turq-dark mt-5 hover:underline">← Back to website</a>
      </div>
    </div>
  );
}
